

import styled from "styled-components";
export const LinksWrapper = styled.div(
  props => `
    padding: ${props.theme.spacing.custom(24)};
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: ${props.theme.spacing.custom(40)};
    justify-content: center;
    max-width: ${props.theme.spacing.custom(1440)};
    margin: 0 auto;
`
);
export const LinksList = styled.ul`
  flex: 1;
`;
export const LinksListItem = styled.li(
    props => `
    a {
        font-size: ${props.theme.font.custom(14)};
        margin-top: ${props.theme.spacing.custom(10)};
        display: inline-block;
        &:hover {
            color: ${props.theme.colors.goBrand.orange};
        }
    }
  
`
);
export const LinksListItemTitle = styled.li(
    props => `
    font-size: ${props.theme.font.custom(18)};
    margin-bottom: ${props.theme.spacing.custom(8)};
    font-family: quicksand;
    font-weight: 700;
`
);
